import axios from './axios.js'
import url from './urls.js'

export default {
  // Auth
  login: (data) => axios.post(url.login, data.params),
  logout: (data) => axios.post(url.logout, data.params),

  // Leftbar
  getDeviceList: (data) => axios.get(`${url.devices}?${new URLSearchParams(data).toString()}`),
  getBackup: (data) => axios.post(url.backup, data.params, data.headers),

  // Dashboard
  dashboard: {
    getSummaryGraph: (data) => axios.get(`${url.dashboard}/graph?${new URLSearchParams(data).toString()}`),
    getConversationCount: (data) => axios.get(`${url.dashboard}/conversation_count?${new URLSearchParams(data).toString()}`),
    getAverageEngagementTime: (data) => axios.get(`${url.dashboard}/aet?${new URLSearchParams(data).toString()}`),
    getFAQ: (data) => axios.get(`${url.dashboard}/faq?${new URLSearchParams(data).toString()}`),
    getBotisfyFunnel: (data) => axios.get(`${url.dashboard}/funnel?${new URLSearchParams(data).toString()}`)
  },

  // Category
  getCategoryList: (data) => axios.get(`${url.category}?${new URLSearchParams(data).toString()}`),
  addCategory: (data) => axios.post(url.category, data.params),
  updateCategory: (data) => axios.put(`${url.category}`, data.params),
  deleteCategory: (data) => axios.delete(url.category, { data: data.params }),

  // ai configuration
  getDeviceAiConfigSettings: (data) => axios.get(`${url.ai_config_setting}?${new URLSearchParams(data).toString()}`),
  updateAiConfigRelatedIntent: (data) => axios.put(url.ai_config_related_intents_on_off, data.params),
  updateAiConfigChatbot: (data) => axios.put(url.ai_config_chatbot_on_off, data.params),
  updateAiConfigMrc: (data) => axios.put(url.ai_config_mrc_on_off, data.params),

  // Question Topic
  getQuestionTopicList: (data) => axios.get(`${url.intents}?${new URLSearchParams(data).toString()}`),
  getQuestionTopicNav: (data) => axios.get(`${url.intent_nav}?${new URLSearchParams(data).toString()}`),
  getQuestionTopicAutocomplete: (data) => axios.get(`${url.intent_autocomplete}?${new URLSearchParams(data).toString()}`),
  addQuestionTopic: (data) => axios.post(url.intents, data.params),
  updateQuestionTopic: (data) => axios.put(`${url.intents}`, data.params),
  deleteQuestionTopic: (data) => axios.delete(url.intents, { data: data.params }),

  // Intent Title
  renameIntent: (data) => axios.put(`${url.intent_title}`, data.params),
  intentExport: (data) => axios.get(`${url.intent_export}?${new URLSearchParams(data).toString()}`, { responseType: 'blob' }),

  // Keyword
  getKeywordList: (data) => axios.get(`${url.keyword}?${new URLSearchParams(data).toString()}`),
  getButtonTriggerKeywordList: (data) => axios.get(`${url.button_payloads}?${new URLSearchParams(data).toString()}`),
  addKeyword: (data) => axios.post(url.keyword, data.params),
  updateKeyword: (data) => axios.put(`${url.keyword}`, data.params),
  deleteKeyword: (data) => axios.delete(url.keyword, { data: data.params }),

  // Topic Data Finder
  getTopicLayer: (data) => axios.get(`${url.column_finder}?${new URLSearchParams(data).toString()}`),
  getTopicDataFinder: (data) => axios.get(`${url.finder}?${new URLSearchParams(data).toString()}`),

  // Copy Device to another device
  transferDeviceData: (data) => axios.post(url.copy_device, data.params),

  // Response
  getResponseList: (data) => axios.get(`${url.response}?${new URLSearchParams(data).toString()}`),
  addResponse: (data) => axios.post(url.response, data.params),
  updateResponse: (data) => axios.put(`${url.response}`, data.params),
  deleteResponse: (data) => axios.delete(url.response, { data: data.params }),
  uploadImageFile: (data) => axios.post(url.upload_file, data.params),

  // Response - avatar motion
  getAvatarMotionList: (data) => axios.get(`${url.avatar_motion}?${new URLSearchParams(data).toString()}`),
  updateAvatarMotion: (data) => axios.put(url.avatar_motion, data.params),
  getAvatarMotionPreview: (data) => axios.get(`${url.avatar_motion}/preview?${new URLSearchParams(data).toString()}`),

  // Entity
  getEntityList: (data) => axios.get(`${url.entity}?${new URLSearchParams(data).toString()}`),
  updateEntity: (data) => axios.put(`${url.entity}`, data.params),
  deleteEntity: (data) => axios.delete(url.entity, { data: data.params }),

  // Alias card
  getAliasList: (data) => axios.get(`${url.alias_finder}?${new URLSearchParams(data).toString()}`),
  createAlias: (data) => axios.post(url.alias_finder, data.params),

  // MRC
  getMrcDocList: (data) => axios.get(`${url.mrc}?${new URLSearchParams(data).toString()}`),
  addMrcDoc: (data) => axios.post(url.mrc, data.params, data.headers),
  deleteMrcDoc: (data) => axios.delete(url.mrc, { data: data.params }),
  batchDeleteMrcDoc: (data) => axios.delete(url.mrc_batch, { data: data.params }),
  batchToggleMrcDocEnable: (data) => axios.put(url.mrc_batch_enable, data.params),
  readMrcProject: (data) => axios.get(`${url.mrc_projects}?${new URLSearchParams(data).toString()}`),
  createMrcProject: (data) => axios.post(url.mrc_projects, data.params),
  queryMrc: (data) => axios.post(url.mrc_query, data.params),
  toggleMrcDocEnable: (data) => axios.put(url.mrc_enable, data.params),
  getMrcHealthcheck: () => axios.get(url.mrc_healthcheck),
  previewMrcDocument: (data) => axios.get(`${url.mrc_document}?${new URLSearchParams(data).toString()}`, { responseType: 'blob' }),
  exportMrcDocList: (data) => axios.post(url.mrc_export, data.params, { responseType: 'blob' }),

  // Location and Map
  getLocationList: (data) => axios.get(`${url.location}?${new URLSearchParams(data).toString()}`),
  getLocation: (data) => axios.get(`${url.location}/${data.location_id}?${new URLSearchParams(data.params).toString()}`),
  getMapList: (data) => axios.get(`${url.map}?${new URLSearchParams(data).toString()}`),
  getCategoryTree: (data) => axios.get(`${url.location_map_category}/tree?${new URLSearchParams(data).toString()}`),
  getCategoryColumn: (data) => axios.get(`${url.location_map_category}/column?${new URLSearchParams(data).toString()}`),
  createLocation: (data) => axios.post(url.location, data),
  updateLocation: (data) => axios.put(`${url.location}/${data.location_id}`, data.params),
  deleteLocation: (data) => axios.delete(`${url.location}/${data.location_id}`, { data: data.params }),
  addCategoryLayer: (data) => axios.post(url.location_map_category, data),
  updateCategoryLayer: (data) => axios.put(`${url.location_map_category}/${data.category_id}`, data.params),
  deleteCategoryLayer: (data) => axios.delete(`${url.location_map_category}/${data.category_id}`, { data: data.params }),
  updateMap: (data) => axios.put(`${url.map}/${data.map_id}`, data.params),

  // Small talk - Setting
  getSmalltalkSetting: (data) => axios.get(`${url.small_talk}/settings?${new URLSearchParams(data).toString()}`),
  updateSmalltalkSetting: (data) => axios.put(`${url.small_talk}/settings`, data.params),

  // Small talk - Customizable Questions
  getSmallTalkQuestion: (data) => axios.get(`${url.small_talk}/questions?${new URLSearchParams(data).toString()}`),
  updateSmallTalkQuestion: (data) => axios.put(`${url.small_talk}/questions`, data.params),

  // Small talk - Topic Filter
  getSmallTalkTopicFilters: (data) => axios.get(`${url.small_talk}/topic_filters?${new URLSearchParams(data).toString()}`),
  updateSmallTalkTopicFilters: (data) => axios.put(`${url.small_talk}/topic_filters`, data.params),

  // Small talk - Set Prompt
  getSmallTalkPrompt: (data) => axios.get(`${url.small_talk}/prompt?${new URLSearchParams(data).toString()}`),
  setSmallTalkPrompt: (data) => axios.put(`${url.small_talk}/prompt`, data.params),

  // Interface Setting
  getSectionList: (data) => axios.get(`${url.interface_setting}?${new URLSearchParams(data).toString()}`),
  updateSection: (data) => axios.put(`${url.interface_setting}`, data.params),

  // Conversation
  getConversation: (data) => axios.get(`${url.conversation}?${new URLSearchParams(data).toString()}`),
  bookmarkConversation: (data) => axios.put(url.conversation, data.params),
  downloadConversation: (data) => axios.get(`${url.conversation}/download?${new URLSearchParams(data).toString()}`, { responseType: 'blob' }),
  trainIntent: (data) => axios.post(`${url.conversation}/train`, data.params),

  // Directory
  getDirectoryList: (data) => axios.get(`${url.directory}?${new URLSearchParams(data).toString()}`),
  addUnit: (data) => axios.post(url.directory, data.params, data.headers),
  updateUnit: (data) => axios.put(url.directory, data.params, data.headers),
  deleteUnit: (data) => axios.delete(url.directory, { data: data.params }),

  // Carousel Banner
  getCarouselBannerList: (data) => axios.get(`${url.carousel}?${new URLSearchParams(data).toString()}`),
  uploadCarouselBannerMediaFile: (data) => axios.post(`${url.carousel}/upload`, data.params, data.headers),
  updateCarouselBanner: (data) => axios.put(`${url.carousel}`, data.params),
  deleteCarouselBanner: (data) => axios.delete(`${url.carousel}`, { data: data.params }),

  // Bottom Menu
  getBottomMenuList: (data) => axios.get(`${url.bottom_menu}?${new URLSearchParams(data).toString()}`),
  uploadBottomMenuImage: (data) => axios.post(`${url.bottom_menu}/upload`, data.params, data.headers),
  updateBottomMenu: (data) => axios.put(`${url.bottom_menu}`, data.params),

  // User
  getUserList: (data) => axios.get(`${url.user}?${new URLSearchParams(data).toString()}`),
  addUser: (data) => axios.post(url.user, data.params, data.headers),
  updateUser: (data) => axios.put(url.user, data.params, data.headers),
  updateUserPassword: (data) => axios.put(url.change_password, data.params, data.headers),
  deleteUser: (data) => axios.delete(url.user, { data: data.params }),
  getUserRoles: (data) => axios.get(`${url.user}/roles?${new URLSearchParams(data).toString()}`),

  // Logs
  getLogRecords: (data) => axios.get(`${url.logs}?${new URLSearchParams(data).toString()}`),
  downloadLogs: (data) => axios.get(`${url.logs}/csv?${new URLSearchParams(data).toString()}`, { responseType: 'blob' }),

  // Chat
  getChatList: (data) => axios.get(`${url.chat}/endusers?${new URLSearchParams(data).toString()}`),
  getChatDetail: (data) => axios.get(`${url.chat}/endusers/${data.session_id}?${new URLSearchParams(data.params).toString()}`),
  getChatMessage: (data) => axios.get(`${url.chat}/history/${data.session_id}?${new URLSearchParams(data).toString()}`),
  sentChatMessage: (data) => axios.post(`${url.chat}/send`, data.params, data.headers),

  // Live Video
  getLiveVideoList: (data) => axios.get(`${url.video_call}/${data}`),
  getOfflineHours: (data) => axios.get(`${url.offline_hours}/${data}`),
  getNotificationChannel: (data) => axios.get(`${url.notification_channel}/${data}`),
  getLiveVideoCallHistory: (data) => axios.get(`${url.video_call}/${data.device_id}?${new URLSearchParams(data.params).toString()}`),
  pushMessage: (data) => axios.post(url.message, data.params),
  updateVideoCallStatus: (data) => axios.put(`${url.video_call}/${data.device_id}`, data.params),
  updateNotification: (data) => axios.put(`${url.notification_channel}/${data.device_id}`, data.params),
  updateOfflineHours: (data) => axios.put(`${url.offline_hours}/${data.device_id}`, data.params),

  // Idle Screen
  getIdleScreen: (data) => axios.get(`${url.idle_screen}?${new URLSearchParams(data).toString()}`),
  getIdleScreenMedia: (data) => axios.get(`${url.idle_screen}/${data.media_type}?${new URLSearchParams(data.params).toString()}`),
  uploadIdleScreenMediaFile: (data) => axios.post(`${url.idle_screen}`, data.params, data.headers),
  updateIdleScreen: (data) => axios.put(`${url.idle_screen}`, data.params),
  deleteIdleScreen: (data) => axios.delete(`${url.idle_screen}`, { data: data.params }),

  // Branding Images
  getBranding: (data) => axios.get(`${url.branding}?${new URLSearchParams(data || {}).toString()}`),
  uploadBrandingImage: (data) => axios.post(`${url.branding}/upload`, data.params, data.headers),
  deleteBrandingImage: (data) => axios.delete(`${url.branding}`, { data: data.params }),

  // Virtual Avatar
  getAvatarType: (data) => axios.get(`${url.avatar}/type?${new URLSearchParams(data).toString()}`),
  getVideoAvatarList: (data) => axios.get(`${url.avatar}/video_avatar?${new URLSearchParams(data).toString()}`),
  generateVideoAvatar: (data) => axios.post(`${url.avatar}/video_avatar/generate`, data.params, data.headers),
  submitGeneratedVideoAvatar: (data) => axios.post(`${url.avatar}/video_avatar`, data.params, data.headers),
  updateVideoAvatar: (data) => axios.put(`${url.avatar}/video_avatar`, data.params, data.headers),
  deleteVideoAvatar: (data) => axios.delete(`${url.avatar}/video_avatar`, { data: data.params }),

  // Event Manager - General
  getEventOverview: (data) => axios.get(`${url.event_manager}/overview?${new URLSearchParams(data).toString()}`),
  uploadEventMediaFile: (data) => axios.post(`${url.event_manager}/upload`, data.params, data.headers),

  // Event Manager - Event
  createEvent: (data) => axios.post(url.event, data.params),
  getEvent: (data) => axios.get(`${url.event}/${data.event_id}?`),
  updateEvent: (data) => axios.put(`${url.event}/${data.event_id}`, data.params),
  deleteEvent: (data) => axios.delete(`${url.event}/${data.event_id}`, { data: data.params }),
  duplicateEvent: (data) => axios.post(`${url.event}/${data.event_id}/duplicate`, data.params),
  // Event Manager - Quiz
  getQuizLibraryList: (data) => axios.get(`${url.quiz}?${new URLSearchParams(data).toString()}`),
  createQuiz: (data) => axios.post(url.quiz, data.params),
  deleteQuiz: (data) => axios.delete(`${url.quiz}/${data.quiz_id}`, { data: data.params }),
  duplicateQuiz: (data) => axios.post(`${url.quiz}/${data.quiz_id}/duplicate`, data.params),
  getQuizDetail: (data) => axios.get(`${url.quiz}/${data.quiz_id}?${new URLSearchParams(data.params).toString()}`),
  updateQuizDetail: (data) => axios.put(`${url.quiz}/${data.quiz_id}`, data.params),
  deleteQuizDetail: (data) => axios.delete(`${url.quiz}/${data.quiz_id}`, { data: data.params }),
  getGeneralPage: (data) => axios.get(`${url.quiz}/${data.quiz_id}/${data.page_type}?${new URLSearchParams(data.params).toString()}`),
  updateGeneralPage: (data) => axios.put(`${url.quiz}/${data.quiz_id}/${data.page_type}`, data.params),

  // Event Manager - Question
  createQuestion: (data) => axios.post(`${url.quiz}/${data.quiz_id}/question`, data.params),
  getQuestionDetail: (data) => axios.get(`${url.quiz}/${data.quiz_id}/question/${data.question_id}?${new URLSearchParams(data.params).toString()}`),
  updateQuestion: (data) => axios.put(`${url.quiz}/${data.quiz_id}/question/${data.question_id}`, data.params),
  deleteQuestion: (data) => axios.delete(`${url.quiz}/${data.quiz_id}/question/${data.question_id}`, { data: data.params }),

  // Approval
  getApprovalStatus: (data) => axios.get(`${url.approval_status}?${new URLSearchParams(data.params).toString()}`),
  getDeviceChanges: (data) => axios.get(`${url.device_changes}?${new URLSearchParams(data.params).toString()}`),
  submitChanges: (data) => axios.post(url.approval_request, data.params),
  cancelSubmission: (data) => axios.delete(url.approval_request, { data: data.params }),
  getApprovalRequest: () => axios.get(`${url.approval_requests}?`),
  getApprovalRequestDetails: (data) => axios.get(`${url.approval_request}?${new URLSearchParams(data.params).toString()}`),
  confirmApprovalRequest: (data) => axios.put(url.approval_request, data.params),

  // Audio Preview
  getAudioPreview: (data) => axios.post(url.audio_preview, data.params, { headers: data.headers })
}
